import React from "react";
import {useSelector} from "react-redux";

import AppreciationTabInputText from "../../component/appreciation/AppreciationTabInputText";
import LoadingIndicator from "../../component/LoadingIndicator";
import {PanelJsonDebug} from "../../component/PanelJsonDebug";
import ValueLendingValueInfo from "../../component/ValueLendingValueInfo";
import {useRevaTranslation} from "../../hooks/languageHooks";
import {useCheckPermissionAdmin} from "../../hooks/permissionHooks";
import {
    selectAllInitialValuationParams,
    selectInitialValuationAdditionalProperties,
    selectInitialValuationOutputParams,
} from "../../redux/objectParametersSlice";
import {selectInitialValuationExecuted, selectPersistenceLoading} from "../../redux/persistenceSlice";
import {selectLoading as selectSpecLoading} from "../../redux/specSlice";
import {formatDateAndTime} from "../../util/dateUtil";
import ErrorMessageContainer from "./ErrorMessageContainer";
import {ObjectOutputGrid} from "./ObjectOutputGrid";

/**
 * @returns {React.JSX.Element}
 */
function TabObjectInitial() {
    const {t, language} = useRevaTranslation();
    const initialValues = useSelector(selectAllInitialValuationParams);
    const initialOutputValues = useSelector(selectInitialValuationOutputParams);
    const initialValuationDate = useSelector(selectInitialValuationExecuted);
    const initialValuationAdditionalProperties = useSelector(selectInitialValuationAdditionalProperties);
    const specLoading = useSelector(selectSpecLoading);
    const persistenceLoading = useSelector(selectPersistenceLoading);
    const isAdmin = useCheckPermissionAdmin();
    const loading = specLoading || persistenceLoading;

    const hasInitialValuationAdditionalProperties = !!initialValuationAdditionalProperties;
    const debugPanelsColClass = hasInitialValuationAdditionalProperties ? "col-span-4" : "col-span-6";

    return (
        <div className="flex-1">
            <AppreciationTabInputText page="object" tab="initialValuation" />
            <ValueLendingValueInfo />
            <ErrorMessageContainer />
            <LoadingIndicator loading={loading} className="h-full" />
            {!loading && (
                <>
                    <div className="text-lg mb-6 py-2 text-color text-center">
                        {initialValuationDate &&
                            t("object.initialValuationExecuted", {
                                date: formatDateAndTime(initialValuationDate, language),
                            })}
                    </div>
                    <ObjectOutputGrid outputData={initialValues} fullsize={true} />
                    {isAdmin && (
                        <div className="grid grid-cols-12 gap-4 mt-4">
                            <div className={debugPanelsColClass}>
                                <PanelJsonDebug
                                    jsonData={initialValues}
                                    title="Historischer AVM-Input: (Admins-Only)"
                                />
                            </div>
                            <div className={debugPanelsColClass}>
                                <PanelJsonDebug
                                    jsonData={initialOutputValues}
                                    title="Historische AVM-Response: (Admins-Only)"
                                />
                            </div>
                            {hasInitialValuationAdditionalProperties && (
                                <div className={debugPanelsColClass}>
                                    <PanelJsonDebug
                                        jsonData={initialValuationAdditionalProperties}
                                        title="Zusätzliche Daten der Erstbewertung: (Admins-Only)"
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default TabObjectInitial;
